import {remCalc} from '_themeUtils'

const price = {
    Price: {
        baseStyle: () => ({
            wrapper: {
                flexWrap: 'wrap',
                columnGap: {base: 'spacing.1', lg: 'spacing.4'},
                rowGap: 'spacing.none',
            },
            price: {
                textStyle: 'paragraphSm',
                letterSpacing: remCalc(0.8),
                whiteSpace: 'nowrap',
            },
            discountedPrice: {
                textDecoration: 'line-through',
                color: 'color.text.grey.600',
            },
        }),
        variants: {
            pdp: {
                wrapper: {
                    // Mobile: stack the current/original prices vertically (Figma 58195:9927),
                    // each on a single line. Desktop: keep them inline on one row.
                    flexDirection: {base: 'column', md: 'row'},
                    alignItems: 'flex-start',
                    columnGap: {base: 'spacing.none', md: 'spacing.4'},
                    rowGap: {base: remCalc(5), md: 'spacing.none'},
                },
                price: {
                    textStyle: {base: 'paragraphSm', md: 'paragraphMd'},
                    color: {base: 'color.text.black', md: 'color.text.grey.600'},
                    fontWeight: {base: 350, md: 400},
                    letterSpacing: remCalc(0.8),
                    whiteSpace: 'nowrap',
                },
            },
            // Sticky bar (desktop): name + price on a single inline row (Figma 58078:30094).
            // Current price sits next to the strikethrough original; kids show the
            // "starting from" range via the shared label handling in the Price component.
            stickybar: {
                wrapper: {
                    flexWrap: 'nowrap',
                    alignItems: 'center',
                    columnGap: 'spacing.4',
                },
                price: {
                    textStyle: 'paragraphMd',
                    fontWeight: 'light',
                    letterSpacing: remCalc(0.8),
                    whiteSpace: 'nowrap',
                },
            },
        },
    },
}

export default price
